/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionIssuersCimdClientsList } from "../funcs/userSessionIssuersCimdClientsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListUserSessionIssuerCimdClientsRequest,
  ListUserSessionIssuerCimdClientsResponse,
  ListUserSessionIssuerCimdClientsSecurity,
} from "../models/operations/listusersessionissuercimdclients.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type UserSessionIssuerCimdClientsQueryData =
  ListUserSessionIssuerCimdClientsResponse;

export type UserSessionIssuerCimdClientsInfiniteQueryData = PageIterator<
  ListUserSessionIssuerCimdClientsResponse,
  { cursor: string }
>;

export type UserSessionIssuerCimdClientsPageParams = PageIterator<
  ListUserSessionIssuerCimdClientsResponse,
  { cursor: string }
>["~next"];

export function prefetchUserSessionIssuerCimdClients(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListUserSessionIssuerCimdClientsRequest,
  security?: ListUserSessionIssuerCimdClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUserSessionIssuerCimdClientsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchUserSessionIssuerCimdClientsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListUserSessionIssuerCimdClientsRequest,
  security?: ListUserSessionIssuerCimdClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildUserSessionIssuerCimdClientsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as UserSessionIssuerCimdClientsPageParams,
    getNextPageParam: (
      previousPage: UserSessionIssuerCimdClientsInfiniteQueryData,
    ) => previousPage["~next"],
  });
}

export function buildUserSessionIssuerCimdClientsQuery(
  client$: GramCore,
  request: ListUserSessionIssuerCimdClientsRequest,
  security?: ListUserSessionIssuerCimdClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<UserSessionIssuerCimdClientsQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionIssuerCimdClients({
      userSessionIssuerId: request.userSessionIssuerId,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function userSessionIssuerCimdClientsQueryFn(
      ctx,
    ): Promise<UserSessionIssuerCimdClientsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(userSessionIssuersCimdClientsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildUserSessionIssuerCimdClientsInfiniteQuery(
  client$: GramCore,
  request: ListUserSessionIssuerCimdClientsRequest,
  security?: ListUserSessionIssuerCimdClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<
      QueryKey,
      UserSessionIssuerCimdClientsPageParams
    >,
  ) => Promise<UserSessionIssuerCimdClientsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionIssuerCimdClientsInfinite({
      userSessionIssuerId: request.userSessionIssuerId,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function userSessionIssuerCimdClientsQuery(
      ctx,
    ): Promise<UserSessionIssuerCimdClientsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(
          userSessionIssuersCimdClientsList(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(
        userSessionIssuersCimdClientsList(
          client$,
          {
            ...request,
            cursor: ctx.pageParam.cursor,
          },
          security,
          mergedOptions,
        ),
      );
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyUserSessionIssuerCimdClients(
  parameters: {
    userSessionIssuerId: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessionIssuersCimdClients", "list", parameters];
}

export function queryKeyUserSessionIssuerCimdClientsInfinite(
  parameters: {
    userSessionIssuerId: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "userSessionIssuersCimdClients",
    "list",
    "infinite",
    parameters,
  ];
}
